type ErrorResponseType = {
  body?: {
    message?: string;
  };
  status: number;
};

type ErrorReturnType = {
  message?: string;
  status: number;
};

const DEFAULT_MESSAGE = 'Oops! Something went wrong, please try again';

export const handleErrorMessage = (err: any, cb?: (data: ErrorReturnType) => void) => {
  err.graphQLErrors.forEach((item: any) => {
    const response = item.extensions.response as ErrorResponseType;

    cb?.({
      status: response.status,
      message: response?.body?.message || DEFAULT_MESSAGE
    })
  });
};

export const getFirstErrorMessage = (err: any) => {
  const response = err?.graphQLErrors?.[0]?.extensions
    ?.response as ErrorResponseType;

  return response?.body?.message || DEFAULT_MESSAGE;
};
